export default __webpack_public_path__ + "static/media/wuyeSix.a8096c79.png";